import "./body.css";
import "./gospel.css"
import Header from "../components/header";
import Footer from "../components/footer";
import gospelImage from "../photos/gospel-cover.png";

import React, { useEffect } from "react";

function Gospel() {
    useEffect(() => {
        document.title = "Josiah Swanson - The Gospel in 30 Days";
    }, []);
    return (
        <>
            <Header />
            <section className="mainbody">
                <a
                    href="https://a.co/d/g5CAidz"
                    rel="noreferrer"
                    target="_blank"
                >
                    <img src={gospelImage} class="gospelimage" alt="The Gospel in 30 Days"></img>
                </a>
                <p class="gospeldesc">
                    <span>The Gospel in 30 Days </span>
                    was written for my youngest brother, Levi.
                    At a time when the gospel message can mean so many things to so many people,
                    we must all return to God's Word to remind ourselves of the truth concerning
                    the God-man. This 30-day devotional is loaded with Scripture, daily discussion
                    questions, and thoughts from the author. You can{" "}
                    <a
                        href="https://a.co/d/g5CAidz"
                        rel="noreferrer"
                        target="_blank"
                    >
                        get the paperback here</a>.
                </p>
                <a
                    href="https://a.co/d/g5CAidz"
                    rel="noreferrer"
                    target="_blank"
                >

                </a>
            </section>
            <Footer />
        </>
    );
}

export default Gospel;
